import { ArrowRightOutlined, LockOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import { useLogin } from "../hooks/useAuth";
import type { LoginRequest } from "../types";

export function LoginForm() {
	const [form] = Form.useForm<LoginRequest>();
	const { mutate: login, isPending } = useLogin();

	const onFinish = (values: LoginRequest) => {
		// Remove spaces from phone and add +998 prefix
		const phoneWithCountryCode = `+998${values.phone.replace(/\s+/g, "")}`;
		login({ ...values, phone: phoneWithCountryCode });
	};

	return (
		<div className="w-full max-w-[380px]">
			<div className="mb-8 flex flex-col items-center text-center">
				<span className="mb-4 flex size-11 items-center justify-center rounded-xl bg-[var(--c-accent)] text-base font-semibold text-white">
					M
				</span>
				<h1 className="m-0 text-[22px] font-semibold tracking-[-0.01em] text-[var(--c-text)]">
					Tizimga kirish
				</h1>
				<p className="mt-1.5 mb-0 text-[13px] text-[var(--c-text-secondary)]">
					Davom etish uchun hisobingizga kiring
				</p>
			</div>

			<div className="rounded-2xl border border-[var(--c-border)] bg-[var(--c-surface)] p-6">
				<Form
					form={form}
					name="login"
					onFinish={onFinish}
					layout="vertical"
					requiredMark={false}
					size="large"
				>
					<Form.Item
						name="phone"
						label="Telefon raqami"
						rules={[
							{ required: true, message: "Telefon raqamini kiriting" },
							{
								pattern: /^\d{9}$/,
								message: "Format: 901234567",
							},
						]}
					>
						<Input
							addonBefore="+998"
							placeholder="901234567"
							autoComplete="tel"
							inputMode="numeric"
							maxLength={9}
							className="numeric"
						/>
					</Form.Item>

					<Form.Item
						name="password"
						label="Parol"
						rules={[
							{ required: true, message: "Parolni kiriting" },
							{ min: 4, message: "Parol kamida 4 belgidan iborat bo'lishi kerak" },
						]}
					>
						<Input.Password
							prefix={<LockOutlined className="text-[var(--c-text-muted)]" />}
							placeholder="••••••••"
							autoComplete="current-password"
						/>
					</Form.Item>

					<Form.Item className="!mb-0 !mt-6">
						<Button
							type="primary"
							htmlType="submit"
							loading={isPending}
							block
							iconPosition="end"
							icon={isPending ? undefined : <ArrowRightOutlined />}
						>
							Kirish
						</Button>
					</Form.Item>
				</Form>
			</div>
		</div>
	);
}
